/* ---------------------------------------------- /*
/* Podcast modal */
/* ---------------------------------------------- */
const podcastModal = document.getElementById('pod_modal');

if (podcastModal) {

  const pod_modal_title = document.getElementById('pod_title');
  const pod_modal_text = document.getElementById('pod_text');
  const pod_modal_link = document.getElementById('pod_link');
  const pod_modal_player = document.getElementById('pod_player');

  podcastModal.addEventListener('show.bs.modal', (e) => {
    // get info
    var pod_block  = e.relatedTarget; // link that triggered the modal
    if (pod_block) {
      // pod content
      var pod_art_link = pod_block.dataset.link;
      var pod_title  = pod_block.querySelector('.podcast_title').textContent;
      var pod_text   = pod_block.querySelector('.podcast_text').innerHTML;
      var pod_media  = pod_block.querySelector('.podcast_media').textContent;
  
      // append to modal
      pod_modal_title.textContent = pod_title;
      pod_modal_text.innerHTML = pod_text;
      pod_modal_link.setAttribute('href', pod_art_link);
  
      // add player
      pod_modal_player.innerHTML = '';
      // in future - use podcaster url!!
      pod_modal_player.innerHTML = '<audio id="pod_audio" class="w-100" src="/podcasts/'+pod_media+'" preload controls>Your browser does not support HTML5 Audio!</audio>';
    }
  });
  
  podcastModal.addEventListener('hide.bs.modal', (e) => {
    pod_modal_player.innerHTML = '';
  });
}